// extracted by mini-css-extract-plugin
module.exports = {"grid":"seance-grid_grid__3QlAf","gridStyle":"seance-grid_gridStyle__2tRa1"};